var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { T } from 'helpers/i18n';
import { toMoney, toDateTime } from 'helpers/Format';
import Report from '../components/Report';
let CashDesks = class CashDesks extends Component {
    componentDidMount() {
        this.props.store.reports.readCashDesk();
    }
    render() {
        const { reports } = this.props.store;
        const headers = ['state', 'date', 'cashAmount', 'cardAmount'];
        const items = reports.cashDesks;
        return (React.createElement(Report, { header: headers, items: items, loading: !reports.cashDesksLoaded, keyExtractor: (cashDesk) => String(cashDesk.id), format: (cashDesks) => cashDesks.map(cashDesk => (Object.assign(Object.assign({}, cashDesk), { state: T(cashDesk.state), date: toDateTime(cashDesk.date), cashAmount: toMoney(cashDesk.cashAmount), cardAmount: toMoney(cashDesk.cardAmount) }))) }));
    }
};
CashDesks = __decorate([
    inject('store'),
    observer
], CashDesks);
export default CashDesks;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Reports/containers/CashDesk.tsx
// module id = 501
// module chunks = 0